'use strict';

const BuildMoment = require('moment');
const Constants = require('../constants');
const BasePresenter = require('./base');

class DatePresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    return {
      title: this.getTitle(),
      selected: (this.options.selected && this.options.selected.isEqual(this.model)) || false,
    };
  }

  getTitle() {
    const dateString = this.model.toString();
    const momentDate = BuildMoment(dateString);
    return momentDate.isValid() ? momentDate.format(Constants.date.titleFormat) : dateString;
  }
}

module.exports = DatePresenter;
